// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-heading {
  background: #fff;
  padding: 48px 0 0;
}
.profile-heading-grid {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) 190px;
  gap: 32px;
  align-items: center;
}
.profile-label {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #6a8391;
}
.profile-copy h1 {
  font-size: 44px;
  line-height: 1.16;
  font-weight: 650;
  margin: 0 0 14px;
  overflow-wrap: anywhere;
}
.profile-dates {
  margin: 0 0 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px 18px;
  color: #5d7583;
  font-size: 16px;
}
.profile-dates strong {
  font-weight: 500;
  color: #64727b;
}
.profile-description {
  font-size: 15px;
  color: #64727b;
  margin: 0;
  line-height: 1.65;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.profile-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  margin-top: 18px;
  color: #70808b;
  font-size: 13px;
}
.profile-stats a {
  color: inherit;
  text-decoration: none;
}
.profile-commands {
  display: flex;
  flex-direction: column;
  gap: 11px;
}
.profile-start-projection {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  background: transparent;
  color: #638174;
  font-size: 13px;
  min-height: 36px;
  padding: 0;
}
.profile-projection-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0 18px;
}
.profile-filterbar {
  position: sticky;
  top: 0;
  z-index: 15;
  background: #fffffffa;
  border-block: 1px solid var(--site-border);
}
.profile-filter-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 75px;
}
.profile-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.profile-filters button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  background: transparent;
  color: #6a7a85;
  padding: 8px 13px;
  font-size: 14px;
  min-height: 38px;
}
.profile-filters button[aria-pressed='true'] {
  background: #eaf2f8;
  border-color: #d6e5f0;
  color: #416f9d;
}
.profile-filters button span {
  font-size: 11px;
  opacity: 0.8;
  font-variant-numeric: tabular-nums;
}
.profile-view-tools {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.profile-stream {
  padding-top: 30px;
}
.memory-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
}
.memory-stream-end {
  text-align: center;
  color: #71808b;
  font-size: 14px;
  padding: 24px 0 32px;
  min-height: 65px;
}
.profile-contributor-heading {
  display: flex;
  align-items: baseline;
  gap: 16px 32px;
  padding-block: 22px;
  margin-top: 30px;
  border-top: 1px solid var(--site-border);
  scroll-margin-top: 18px;
}
.profile-contributor-heading h2 {
  flex-shrink: 0;
  margin: 0;
  color: #6a8391;
  font-size: 13px;
  font-weight: 600;
}
.profile-contributor-heading > p {
  margin: 0;
  font-size: 13px;
}
.profile-contributors {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 28px;
  min-width: 0;
  padding: 0;
  margin: 0;
  list-style: none;
}
.profile-contributors li {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 13px;
}
.contributor-initials {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #e8f0f5;
  color: #648399;
  font-size: 12px;
}
.profile-contributors li:nth-child(3n) .contributor-initials {
  background: #e8f0eb;
  color: #567f65;
}
.profile-contributors strong,
.profile-contributors small {
  display: block;
  overflow-wrap: anywhere;
}
.profile-contributors small {
  color: #7c8b94;
  font-size: 12px;
}
.profile-muted {
  color: #71808b;
}
.site-footer a:last-child {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.profile-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: #243b4c66;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 16px;
  overflow-y: auto;
}
.profile-modal {
  width: min(820px, 100%);
  max-height: calc(100dvh - 64px);
  overflow-y: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 18px 65px #1a2b3d35;
  padding: 24px;
}
.profile-modal-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.profile-modal-heading h2 {
  margin: 0;
  font-size: 23px;
  font-weight: 600;
}
.profile-modal-heading .site-icon {
  flex-shrink: 0;
}
.profile-modal .add-memory {
  padding: 0;
  box-shadow: none;
  border: 0;
}
.profile-modal .add-memory-header h1,
.profile-modal .add-memory-header p {
  display: none;
}
@media (max-width: 1000px) {
  .profile-heading-grid {
    grid-template-columns: 120px minmax(0, 1fr);
    gap: 25px;
  }
  .profile-heading .profile-avatar {
    width: 120px;
    height: 120px;
  }
  .profile-commands {
    grid-column: 2;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .profile-copy h1 {
    font-size: 37px;
  }
  .memory-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .profile-heading {
    padding: 28px 0 0;
  }
  .profile-heading-grid {
    grid-template-columns: 76px minmax(0, 1fr);
    gap: 18px;
    align-items: start;
  }
  .profile-heading .profile-avatar {
    width: 76px;
    height: 76px;
    font-size: 25px;
  }
  .profile-copy h1 {
    font-size: 30px;
    margin-bottom: 10px;
  }
  .profile-label {
    margin-bottom: 6px;
    font-size: 12px;
  }
  .profile-dates {
    font-size: 14px;
  }
  .profile-description {
    font-size: 14px;
  }
  .profile-stats {
    gap: 5px 15px;
    font-size: 12px;
    margin-top: 12px;
  }
  .profile-commands {
    grid-column: 1 / -1;
    gap: 10px;
  }
  .profile-commands .site-button {
    flex: 1;
    padding-inline: 10px;
  }
  .profile-start-projection {
    min-height: 30px;
  }
  .profile-projection-actions {
    width: 100%;
  }
  .profile-filter-inner {
    min-height: 92px;
    gap: 12px;
  }
  .profile-filters {
    gap: 2px;
  }
  .profile-filters button {
    padding: 6px 9px;
    font-size: 12px;
    min-height: 34px;
  }
  .profile-view-tools {
    flex-direction: column;
    gap: 4px;
    padding-block: 9px;
  }
  .profile-view-tools .site-icon {
    width: 30px;
    height: 30px;
    min-height: 30px;
  }
  .profile-stream {
    padding-top: 20px;
  }
  .memory-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
  }
  .profile-contributor-heading {
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
    padding-block: 18px;
  }
  .profile-contributors {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
  .profile-modal-backdrop {
    padding: 12px 8px;
  }
  .profile-modal {
    padding: 16px;
    max-height: calc(100dvh - 24px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/MemorialPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,aAAa;AACf;AACA;EACE;IACE,2CAA2C;IAC3C,SAAS;EACX;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,0CAA0C;IAC1C,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,OAAO;IACP,oBAAoB;EACtB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,+BAA+B;EACjC;AACF","sourcesContent":[".profile-heading {\n  background: #fff;\n  padding: 48px 0 0;\n}\n.profile-heading-grid {\n  display: grid;\n  grid-template-columns: 150px minmax(0, 1fr) 190px;\n  gap: 32px;\n  align-items: center;\n}\n.profile-label {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6a8391;\n}\n.profile-copy h1 {\n  font-size: 44px;\n  line-height: 1.16;\n  font-weight: 650;\n  margin: 0 0 14px;\n  overflow-wrap: anywhere;\n}\n.profile-dates {\n  margin: 0 0 12px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 10px 18px;\n  color: #5d7583;\n  font-size: 16px;\n}\n.profile-dates strong {\n  font-weight: 500;\n  color: #64727b;\n}\n.profile-description {\n  font-size: 15px;\n  color: #64727b;\n  margin: 0;\n  line-height: 1.65;\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n.profile-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 20px;\n  margin-top: 18px;\n  color: #70808b;\n  font-size: 13px;\n}\n.profile-stats a {\n  color: inherit;\n  text-decoration: none;\n}\n.profile-commands {\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n}\n.profile-start-projection {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 0;\n  background: transparent;\n  color: #638174;\n  font-size: 13px;\n  min-height: 36px;\n  padding: 0;\n}\n.profile-projection-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0 18px;\n}\n.profile-filterbar {\n  position: sticky;\n  top: 0;\n  z-index: 15;\n  background: #fffffffa;\n  border-block: 1px solid var(--site-border);\n}\n.profile-filter-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  min-height: 75px;\n}\n.profile-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.profile-filters button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 1px solid transparent;\n  border-radius: 5px;\n  background: transparent;\n  color: #6a7a85;\n  padding: 8px 13px;\n  font-size: 14px;\n  min-height: 38px;\n}\n.profile-filters button[aria-pressed='true'] {\n  background: #eaf2f8;\n  border-color: #d6e5f0;\n  color: #416f9d;\n}\n.profile-filters button span {\n  font-size: 11px;\n  opacity: 0.8;\n  font-variant-numeric: tabular-nums;\n}\n.profile-view-tools {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.profile-stream {\n  padding-top: 30px;\n}\n.memory-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  align-items: stretch;\n}\n.memory-stream-end {\n  text-align: center;\n  color: #71808b;\n  font-size: 14px;\n  padding: 24px 0 32px;\n  min-height: 65px;\n}\n.profile-contributor-heading {\n  display: flex;\n  align-items: baseline;\n  gap: 16px 32px;\n  padding-block: 22px;\n  margin-top: 30px;\n  border-top: 1px solid var(--site-border);\n  scroll-margin-top: 18px;\n}\n.profile-contributor-heading h2 {\n  flex-shrink: 0;\n  margin: 0;\n  color: #6a8391;\n  font-size: 13px;\n  font-weight: 600;\n}\n.profile-contributor-heading > p {\n  margin: 0;\n  font-size: 13px;\n}\n.profile-contributors {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 28px;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.profile-contributors li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  font-size: 13px;\n}\n.contributor-initials {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #e8f0f5;\n  color: #648399;\n  font-size: 12px;\n}\n.profile-contributors li:nth-child(3n) .contributor-initials {\n  background: #e8f0eb;\n  color: #567f65;\n}\n.profile-contributors strong,\n.profile-contributors small {\n  display: block;\n  overflow-wrap: anywhere;\n}\n.profile-contributors small {\n  color: #7c8b94;\n  font-size: 12px;\n}\n.profile-muted {\n  color: #71808b;\n}\n.site-footer a:last-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.profile-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background: #243b4c66;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 32px 16px;\n  overflow-y: auto;\n}\n.profile-modal {\n  width: min(820px, 100%);\n  max-height: calc(100dvh - 64px);\n  overflow-y: auto;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 18px 65px #1a2b3d35;\n  padding: 24px;\n}\n.profile-modal-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.profile-modal-heading h2 {\n  margin: 0;\n  font-size: 23px;\n  font-weight: 600;\n}\n.profile-modal-heading .site-icon {\n  flex-shrink: 0;\n}\n.profile-modal .add-memory {\n  padding: 0;\n  box-shadow: none;\n  border: 0;\n}\n.profile-modal .add-memory-header h1,\n.profile-modal .add-memory-header p {\n  display: none;\n}\n@media (max-width: 1000px) {\n  .profile-heading-grid {\n    grid-template-columns: 120px minmax(0, 1fr);\n    gap: 25px;\n  }\n  .profile-heading .profile-avatar {\n    width: 120px;\n    height: 120px;\n  }\n  .profile-commands {\n    grid-column: 2;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  .profile-copy h1 {\n    font-size: 37px;\n  }\n  .memory-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 600px) {\n  .profile-heading {\n    padding: 28px 0 0;\n  }\n  .profile-heading-grid {\n    grid-template-columns: 76px minmax(0, 1fr);\n    gap: 18px;\n    align-items: start;\n  }\n  .profile-heading .profile-avatar {\n    width: 76px;\n    height: 76px;\n    font-size: 25px;\n  }\n  .profile-copy h1 {\n    font-size: 30px;\n    margin-bottom: 10px;\n  }\n  .profile-label {\n    margin-bottom: 6px;\n    font-size: 12px;\n  }\n  .profile-dates {\n    font-size: 14px;\n  }\n  .profile-description {\n    font-size: 14px;\n  }\n  .profile-stats {\n    gap: 5px 15px;\n    font-size: 12px;\n    margin-top: 12px;\n  }\n  .profile-commands {\n    grid-column: 1 / -1;\n    gap: 10px;\n  }\n  .profile-commands .site-button {\n    flex: 1;\n    padding-inline: 10px;\n  }\n  .profile-start-projection {\n    min-height: 30px;\n  }\n  .profile-projection-actions {\n    width: 100%;\n  }\n  .profile-filter-inner {\n    min-height: 92px;\n    gap: 12px;\n  }\n  .profile-filters {\n    gap: 2px;\n  }\n  .profile-filters button {\n    padding: 6px 9px;\n    font-size: 12px;\n    min-height: 34px;\n  }\n  .profile-view-tools {\n    flex-direction: column;\n    gap: 4px;\n    padding-block: 9px;\n  }\n  .profile-view-tools .site-icon {\n    width: 30px;\n    height: 30px;\n    min-height: 30px;\n  }\n  .profile-stream {\n    padding-top: 20px;\n  }\n  .memory-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 20px;\n  }\n  .profile-contributor-heading {\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 20px;\n    padding-block: 18px;\n  }\n  .profile-contributors {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px;\n  }\n  .profile-modal-backdrop {\n    padding: 12px 8px;\n  }\n  .profile-modal {\n    padding: 16px;\n    max-height: calc(100dvh - 24px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
